import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { FeiraModel } from "./model/event.model";
import { FiltrarFeira } from "./models/feira-filter.model";
import { FeirasResponseDto } from "./models/feira-response.dto";

@Injectable({
  providedIn: "root",
})
export class EventService {
  private _apiUrl = environment.apiUrl + "/v1";
  constructor(private httpClient: HttpClient) {}

  getEvents(): Observable<FeiraModel[]> {
    // Usar consultarFeira para manter compatibilidade com o novo formato de resposta
    const filtro: FiltrarFeira = {
      paginaAtual: '1',
      quantidadePorPagina: '1000' // Buscar todas as feiras para manter compatibilidade
    };
    
    return this.consultarFeira(filtro).pipe(
      map((response: FeirasResponseDto) => response.feiras || [])
    );
  }

  createEvent(data: FeiraModel) {
    return this.httpClient.post(`${this._apiUrl}/Feiras`, { nome: data.nome });
  }

  deleteEvent(id: string) {
    return this.httpClient.delete(`${this._apiUrl}/Feiras/${id}`);
  }

  updateEvent(id: string, data: FeiraModel) {
    return this.httpClient.put(`${this._apiUrl}/Feiras/${id}`, {
      nome: data.nome,
      id: data.id,
    });
  }

  getEventById(id: string) {
    return this.httpClient.get<FeiraModel>(`${this._apiUrl}/Feiras/${id}`);
  }

  consultarFeira(filtro: FiltrarFeira): Observable<FeirasResponseDto> {
    let params = new HttpParams();
    
    // Definir valores padrão se não fornecidos
    const paginaAtual = filtro.paginaAtual || "1";
    const quantidadePorPagina = filtro.quantidadePorPagina || "10";
    
    // Adicionar parâmetros de paginação (API espera camelCase conforme documentação)
    params = params.append('paginaAtual', paginaAtual);
    params = params.append('quantidadePorPagina', quantidadePorPagina);
    
    // Adicionar filtro por nome se fornecido
    if (filtro.nome && filtro.nome.trim() !== '') {
      params = params.append('nome', filtro.nome.trim());
    }
    
    // Endpoint correto conforme documentação: GET /api/v1/Feiras
    return this.httpClient.get<FeirasResponseDto>(`${this._apiUrl}/Feiras`, { params });
  }
}
